import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// KTK-222 — Model swap from the Agent V2 chat surface settings drawer.
// KTK-243 — Replaced the hardcoded POPULAR_MODELS dropdown + custom
// override with the OpenRouter fuzzy-search autocomplete.
import { useState } from "react";
import { OpenRouterModelPicker } from "./OpenRouterModelPicker.js";
export function ModelPicker({ activeModel, onSave }) {
    const [draftModel, setDraftModel] = useState(activeModel);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const dirty = draftModel.trim() !== "" && draftModel.trim() !== activeModel;
    const handleSave = async () => {
        if (!dirty || saving)
            return;
        setSaving(true);
        setError(null);
        try {
            await onSave(draftModel.trim());
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
        finally {
            setSaving(false);
        }
    };
    return (_jsxs("div", { className: "card", children: [_jsxs("div", { className: "card__head", children: [_jsx("span", { className: "card__title", children: "Active model" }), _jsx("span", { className: "card__sub mono", children: activeModel })] }), _jsx(OpenRouterModelPicker, { value: draftModel, onChange: setDraftModel, variant: "compact" }), error && (_jsx("div", { style: {
                    fontSize: "var(--fs-meta)",
                    color: "var(--accent-ink)",
                    background: "var(--accent-soft)",
                    padding: "6px 8px",
                    borderRadius: "var(--radius-sm)",
                }, children: error })), _jsxs("div", { className: "card__foot", children: [_jsx("span", { className: "hint", children: dirty ? "Takes effect on the next turn." : "Pick a different model to enable save." }), _jsx("button", { type: "button", className: `btn btn--primary ${!dirty || saving ? "btn--disabled" : ""}`, onClick: () => void handleSave(), disabled: !dirty || saving, children: saving ? "saving…" : "save model" })] })] }));
}
//# sourceMappingURL=ModelPicker.js.map